module.exports = __webpack_public_path__ + "static/media/32.d927db26.png";